<template>
  <div>
    <div class="page">
      <div class="page1">

        <div class="main2 flex-col test test-1">
          <div class="bd7 flex-row">
            <img class="icon2" referrerpolicy="no-referrer" src="./assets/img/fanhui.png" />
            <span class="word22" @click="fanhui()">返回</span>
            <div class="block3 flex-col"></div>
            <span class="word4">{{ this.$route.query.id ? '编辑岗位' : '新增岗位' }}</span>
          </div>
          <div class="outer5 flex-row justify-between">
            <div class="layer6">
              <span class="word5">*</span>
              <span class="word6">职位名称</span>
            </div>
            <el-input class="layer7" v-model="name" placeholder="请输入内容"></el-input>
          </div>
          <div class="outer6 flex-row">
            <div class="outer7">
              <span class="word5">*</span>
              <span class="txt4">发布时间</span>
              <el-date-picker class="outer8" v-model="releaseTime" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
          <div class="outer14 flex-row">
            <div class="section2">
              <span class="word5">*</span>
              <span class="word8">发布状态</span>
            </div>
            <el-button :class="['section4', { 'cur': status == item.value }]" @click="iscur(item.value)"
              v-for="item in positionStatus" :key="item.pId">{{ item.label }}</el-button>
          </div>
          <div class="outer15 flex-row">
            <div class="wrap2">
              <span class="word5">*</span>
              <span class="txt7">学历要求</span>
            </div>
            <el-select class="wrap3 flex-col" v-model="edu.label" clearable placeholder="请选择学历">
              <el-option v-for="item in positionEdu" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div class="wrap4">
              <span class="word5">*</span>
              <span class="word11">经验要求</span>
            </div>
            <el-select class="wrap3 flex-col" v-model="workYear" clearable placeholder="请选择工作经验">
              <el-option v-for="item in positionWorkYear" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="outer16 flex-row">
            <div class="section7">
              <span class="word5">*</span>
              <span class="word13">薪资范围</span>
            </div>
            <el-select class="section8" v-model="salary.label" clearable placeholder="请选择工作经验">
              <el-option v-for="item in positionSalary" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div class="section9">
              <span class="word5">*</span>
              <span class="word15">招聘人数</span>
            </div>
            <div class="layer10">
              <el-input class="section10" v-model="needPersonal" placeholder="请输入招聘人数"></el-input>
            </div>
          </div>
          <div class="outer17 flex-row justify-between">
            <div class="block5">
              <span class="word5">*</span>
              <span class="info7">联系人</span>
            </div>
            <el-input class="block6 flex-col" v-model="contactsName" placeholder="请输入联系人"></el-input>
          </div>
          <div class="outer18 flex-row justify-between">
            <div class="box5">
              <span class="word5">*</span>
              <span class="txt9">联系电话</span>
            </div>
            <el-input class="box6 flex-col" v-model="tel" placeholder="请输入联系电话"></el-input>
          </div>
          <div class="outer19 flex-row justify-between">
            <div class="mod2">
              <span class="word5">*</span>
              <span class="txt11">工作地址</span>
            </div>
            <div class="mod3 flex-col" @click="mapVisible = true">
              <el-input filterable v-model="address" placeholder="请选择工作地址">
              </el-input>
            </div>
          </div>

          <BaiduMapWorld :mapVisible="mapVisible" v-on:mapLocationClose="mapLocationClose"
            v-on:mapLocationSave="mapLocationSave">
          </BaiduMapWorld>

          <div class="outer20 flex-row justify-between">
            <span class="txt13">职位类型</span>
            <div class="outer21 flex-col">
              <el-select v-model="positionType.label" clearable placeholder="请选择职位类型">
                <el-option v-for="item in positionTypeList" :key="item.value" :label="item.positionType"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="outer23 flex-row justify-between">
            <span class="word18">福利待遇</span>
            <div class="main5 flex-col">
              <el-select v-model="welfare" multiple placeholder="请选择福利待遇" size="medium">
                <el-option v-for="item in positionWelfare" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="outer25 flex-row justify-between">
            <span class="info9">岗位要求</span>
            <el-input class="bd6s flex-col" type="textarea" :autosize="{ minRows: 8, maxRows: 8 }" placeholder="请输入岗位要求"
              v-model="introduce">
            </el-input>
          </div>
          <div class="outer26 flex-row justify-between">
            <span class="word20">联系邮箱</span>
            <el-input class="box7 flex-col" v-model="email" placeholder="请输入邮箱"></el-input>
          </div>
          <div class="outer19 flex-row justify-between">
            <div class="mod2">
              <span class="word5">*</span>
              <span class="txt11">工作地区</span>
            </div>
            <el-cascader class="mod3 flex-col" v-model="regionCode" :options="options" :props="{
              value: 'id',
              label: 'name',
              children: 'childrenList'
            }" @change="handleChange">
              <!-- <template slot-scope="{ data }">
                  <span>{{ data.name }}</span>
              </template> -->
            </el-cascader>
          </div>
          <div class="outer27 flex-row" @click="_positionSave()">
            <button class="wrap7 flex-col" style="cursor:pointer;"><span class="txt15">提交</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaiduMapWorld from './BaiduMapWorld.vue';
export default {
  components: {
    BaiduMapWorld
  },
  data() {
    return {
      mapVisible: false,

      changeInfo: "",
      labelType: "label",
      isHeight: true,
      minHeight: 0,
      showPicker: false,
      welfareShow: false,
      positionTypeList: [], //职位类型数组
      positionStatus: [], //发布状态数组
      positionEdu: [], //学历数组数组
      positionWorkYear: [], //工作年限数组
      positionSalary: [], //薪资范围数组
      positionWelfare: [], //福利待遇数组
      activeWelfare: [],
      timeShow: false,
      currentDate: new Date(),
      popupShow: false,
      list: [],
      name: "", //岗位名称
      positionType: {
        label: "",
        value: "",
      }, //岗位类型
      status: {}, //发布状态
      edu: {
        label: "",
        value: "",
      }, //学历
      workYear: "", //经验要求

      salary: {
        label: "",
        value: "",
      }, //薪资范围
      welfare: "", //福利待遇
      needPersonal: "", //招聘人数
      introduce: "", //岗位描述
      releaseTime: "", //发布时间
      contactsName: "", //联系人
      tel: "", //联系电话
      email: "", //邮箱
      region: "", //所在地区
      regionCode: [], //所在区id
      address: "", //办公地址
      safeArea: { top: 0, bottom: 0 },
      coordinates: {
        lng: null,
        lat: null,
      }, //经纬度
      companyName: localStorage.getItem("name"), //公司名称
      resumeData: {}, //个人简历
      skillList: [], //技能列表
      page: 1,
      loopData0: [],
      options: []
    }
  },
  methods: {
    //获取百度地图定位坐标
    selectPosition() {
      this.mapVisible = true;
    },
    mapLocationClose() {
      this.mapVisible = false;
    },
    mapLocationSave(param) {
      this.mapVisible = false;
      this.address = param.address;
      this.coordinates.lat = param.latitude;
      this.coordinates.lng = param.longitude;
    },

    fanhui() {
      this.$router.push({ path: 'Talent' })
    },
    iscur(val) {
      this.status = val
    },
    changeFormat(val) {

    },
    _positionSave() {
      let reg = /^(1)[0-9]{10}$/;
      if (this.name == "") {
        this.$message.error("请输入职位名称！");
        return;
      }
      if (this.releaseTime == "") {
        this.$message.error("请选择发布日期！");
        return;
      }
      if (this.positionType.label == "") {
        this.$message.error("请选择职位类型！");
        return;
      }
      if (this.status.label == "") {
        this.$message.error("请选择发布状态！");
        return;
      }
      if (this.edu.label == "") {
        this.$message.error("请选择学历要求！");
        return;
      }
      if (this.workYear == "") {
        this.$message.error("请选择经验要求！");
        return;
      }
      if (this.salary.label == "") {
        this.$message.error("请选择薪资范围！");
        return;
      }
      if (this.needPersonal == "") {
        this.$message.error("请输入招聘人数！");
        return;
      }
      if (this.contactsName.trim() == "") {
        this.$message.error("请输入联系人！");
        return;
      }
      if (this.tel.trim() == "") {
        this.$message.error("请输入联系电话！");
        return;
      }
      if (this.address.trim() == "") {
        this.$message.error("请选择工作地址！！");
        return;
      }
      if (this.tel.trim() == "") {
        this.$message.error("联系电话格式不正确！");
        return;
      }
      if (this.email !== "") {
        if (
          !/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
            this.email
          )
        ) {
          this.$toast("联系邮箱格式不正确！");
          return;
        }
      }
      let form = {
        name: this.name,
        positionTypeId: this.positionType.label,
        region: this.region.split("/")[this.region.split("/").length - 1],
        regionCode: this.regionCode.join(','),
        releaseTime: this.releaseTime,
        status: this.status,
        edu: this.edu.label,
        workYear: this.workYear,
        salary: this.salary.label,
        address: this.address,
        welfare: this.welfare.toString(),
        needPersonal: this.needPersonal,
        contactsName: this.contactsName,
        tel: this.tel,
        email: this.email,
        introduce: this.introduce,
        lng: this.coordinates.lng,
        lat: this.coordinates.lat,
        companyId: localStorage.getItem("id"),
        companyName: this.companyName,
      };
      if (this.$route.query.id) {
        form.id = this.$route.query.id;
      }
      this.$apiFun.positionsave(form).then((data) => {
        if (data.code == 200) {
          if (this.$route.query.id) {
            this.$message({ message: '修改成功！', type: 'success' });
            this.$router.push({ path: '/Talentils', query: { positionId: this.$route.query.id } })
          } else {
            this.$message({ message: '创建成功！', type: 'success' });
            this.$router.push({ path: '/Talent' })
          }
        }
      });
    },
    handleChange(value) {
      console.log(value);
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.$apiFun.getPositionDetail({ id: this.$route.query.id }).then((data) => {
        this.address = data.data.address;
        this.name = data.data.name;
        this.edu.value = data.data.edu;
        this.edu.label = data.data.edu;
        this.salary.value = data.data.salary;
        this.salary.label = data.data.salary;
        this.positionType.value = data.data.positionTypeId;
        this.positionType.label = data.data.positionTypeId;
        this.workYear = data.data.workYear;
        this.releaseTime = data.data.releaseTime;
        this.status = data.data.status;
        this.tel = data.data.tel;
        this.needPersonal = data.data.needPersonal;
        this.contactsName = data.data.contactsName;
        this.introduce = data.data.introduce;
        this.email = data.data.email;
        this.welfare = data.data.welfare.split(',');
        this.regionCode = data.data.regionCode.split(',')

        this.regionCode = this.regionCode.map(item => {
          return item = Number(item)
        })
        this.coordinates.lat = data.data.lat;
        this.coordinates.lng = data.data.lng;
      });
    }
    this.$apiFun.pTypeList().then((data) => { this.positionTypeList = data.data });
    this.$apiFun.dictionary({ code: "recruit.position.edu" }).then((data) => { this.positionEdu = data.data });
    this.$apiFun.dictionary({ code: "recruit.position.workYear " }).then((data) => { this.positionWorkYear = data.data });
    this.$apiFun.dictionary({ code: "recruit.position.salary " }).then((data) => { this.positionSalary = data.data });
    this.$apiFun.dictionary({ code: "recruit.position.welfare " }).then((data) => { this.positionWelfare = data.data });
    this.$apiFun.dictionary({ code: "recruit.position.status " }).then((data) => { this.positionStatus = data.data });
    this.$apiFun.getCityData({}).then((data) => {
      this.options = data.data
    });
  }
}
</script>
<style lang="less" scoped>
.bm-view {
  width: 100%;
  height: 300px;
}

.topimg {
  img {
    width: calc(100% - 40px);
    height: auto;
    margin: 20px;
    object-fit: cover;

  }
}

.page {
  width: calc(100% - 40px);
  margin: 20px;
  height: 88vh;

  .page1 {
    width: 100%;
    height: 88vh;
    border-radius: 4px;
    background: #FFFFFF;
    padding: 0px 20px 0 20px;

    .page1wrap {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      flex-flow: wrap;
    }
  }
}

.test {
  height: 582px;
  overflow: auto;
  float: left;
  margin: 5px;
  border: none;
  border-bottom: none;
}

.scrollbar {
  width: 30px;
  height: 300px;
  margin: 0 auto;
}

.test-1::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.test-1::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}

.test-1::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.cur {
  color: #409EFF;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

/deep/ .el-tag.el-tag--info:nth-child(n + 5) {
  width: 0;
  padding: 0;
  height: 0;
  margin: 0;
  color: rgba(255, 255, 255, 0);
  border-color: unset;
  background: none;

  i {
    display: none;
  }
}

/deep/ .el-tag.el-tag--info:nth-child(5) {
  position: relative;

  &:before {
    content: '...';
    position: absolute;
    left: 4px;
    top: -12px;
    width: 26px;
    height: 24px;
    padding: 0 8px;
    line-height: 22px;
    font-size: 12px;
    background-color: #f4f4f5;
    color: #909399;
    box-sizing: border-box;
    border: 1px solid #e9e9eb;
    border-radius: 4px;
  }
}
</style>


<style scoped lang="less" src="./assets/index.less" />